/*
 Section : Large Hero Banner  
*/
 
(function () {
  const img_vid_slides = document.querySelectorAll(".large-hero-banner-slide");
  const img_vid_progressBar = document.querySelector(".large-hero-progress");
  const img_vid_progressBar_bg = document.querySelector(
    ".large-hero-progress-bar"
  );
  const img_vid_bannerInfos = document.querySelectorAll(
    ".large-hero-banner-info"
  );
  const img_vid_bannerWrapper = document.querySelector(
    ".large-hero-banner-wrapper"
  );
  const MOBILE_BREAKPOINT = 767;
 
  const SLIDE_DURATION = parseInt(
    img_vid_bannerWrapper.getAttribute("data-slide-duration") || 5000,
    10
  );
 
  const img_vid_maxBlocks = parseInt(
    img_vid_bannerWrapper.getAttribute("data-max-blocks"),
    10
  );
 
  let img_vid_currentIndex = 0;
  const img_vid_slideDuration = SLIDE_DURATION;
  let img_vid_slideInterval;
  const videoStates = Array.from(img_vid_slides).map(() => false);
 
  if (img_vid_slides.length === 0) {
    return;
  }
 
  // Function to toggle visibility of progress bar and banner-info
  function img_vid_toggleVisibilityBasedOnBlocks() {
    if (img_vid_maxBlocks === 1 || img_vid_slides.length < img_vid_maxBlocks) {
      if (img_vid_progressBar) img_vid_progressBar.classList.add("hidden");
      img_vid_progressBar_bg.classList.add("hidden");
      img_vid_bannerInfos.forEach((info) => {
        info.classList.add("hidden");
      });
    } else {
      if (img_vid_progressBar) img_vid_progressBar.style.display = "block";
      img_vid_bannerInfos.forEach((info) => {
        info.classList.remove("hidden");
      });
    }
  }
 
  // Helper function to set video attributes
  function setVideoAttributes(video) {
    if (video) {
      video.setAttribute("playsinline", "true");
      video.setAttribute("webkit-playsinline", "true");
      video.muted = true;
    }
  }
 
  // Refactored img_vid_attemptAutoplay function
  function img_vid_attemptAutoplay(video) {
    if (video) {
      setVideoAttributes(video);
      video.play().catch((error) => {
        setVideoAttributes(video);
        video.play();
      });
    }
  }
 
  // Function to show a specific slide
  function img_vid_showSlide(index) {
    img_vid_slides.forEach((slide, i) => {
      slide.classList.remove("active");
      if (i === index) {
        slide.classList.add("active");
 
        const video = slide.querySelector(".large-hero-banner-video");
        if (video) {
          if (videoStates[i]) {
            video.pause();
          } else {
            video.currentTime = 0;
            video.play();
          }
        }
      } else {
        const video = slide.querySelector(".large-hero-banner-video");
        if (video) {
          video.pause();
        }
      }
    });
    img_vid_updatePrevNextInfo(index);
  }
 
  function img_vid_resetProgressBar() {
    if (img_vid_slides.length < img_vid_maxBlocks) return;
    img_vid_progressBar.style.transition = `width ${0}ms linear`;
    img_vid_progressBar.classList.remove("progress-bar-animate");
    void img_vid_progressBar.offsetWidth;
    img_vid_progressBar.style.transition = `width ${SLIDE_DURATION}ms linear`;
    img_vid_progressBar.classList.add("progress-bar-animate");
  }
 
  function img_vid_nextSlide() {
    if (img_vid_slides.length < img_vid_maxBlocks || img_vid_slides.length == 1) return;
    img_vid_currentIndex = (img_vid_currentIndex + 1) % img_vid_maxBlocks;
    img_vid_showSlide(img_vid_currentIndex);
    img_vid_resetProgressBar();
  }
 
  // Function to get the previous and next slide indices
  function img_vid_getPrevNextIndices(index) {
    const prevIndex = (index - 1 + img_vid_maxBlocks) % img_vid_maxBlocks;
    const nextIndex = (index + 1) % img_vid_maxBlocks;
    return { prevIndex, nextIndex };
  }
 
  // Function to update the previous and next slide details
  function img_vid_updatePrevNextInfo(index) {
    const { prevIndex, nextIndex } = img_vid_getPrevNextIndices(index);
 
    const prevSlide = img_vid_slides[prevIndex];
    const prevSerial = prevSlide
      .querySelector(".large-hero-banner-serial")
      ?.textContent.split(" - ")[0];
 
    const prevName = prevSlide
      .querySelector(".large-hero-banner-serial")
      ?.textContent.split(" - ")[1];
 
    const nextSlide = img_vid_slides[nextIndex];
    const nextSerial = nextSlide
      .querySelector(".large-hero-banner-serial")
      ?.textContent.split(" - ")[0];
 
    const nextName = nextSlide
      .querySelector(".large-hero-banner-serial")
      ?.textContent.split(" - ")[1];
 
    const activeSlide = img_vid_slides[index];
    const nextInfo = activeSlide.querySelector(".large-hero-next-slide-info");
    const prevInfo = activeSlide.querySelector(".large-hero-prev-slide-info");
 
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      if (nextInfo) nextInfo.textContent = nextSerial;
      if (prevInfo) prevInfo.textContent = prevSerial;
    }
 
    else {
      if (nextInfo) nextInfo.textContent = `${nextSerial} - ${nextName}`;
      if (prevInfo) prevInfo.textContent = `${prevSerial} - ${prevName}`;
    }
 
    if (prevInfo) {
      prevInfo.onclick = () => {
        img_vid_currentIndex = prevIndex;
        img_vid_showSlide(img_vid_currentIndex);
        img_vid_resetProgressBar();
        img_vid_restartSlideInterval();
      };
    }
 
    if (nextInfo) {
      nextInfo.onclick = () => {
        img_vid_currentIndex = nextIndex;
        img_vid_showSlide(img_vid_currentIndex);
        img_vid_resetProgressBar();
        img_vid_restartSlideInterval();
      };
    }
  }
 
  function img_vid_restartSlideInterval() {
    clearInterval(img_vid_slideInterval);
    img_vid_slideInterval = setInterval(
      img_vid_nextSlide,
      img_vid_slideDuration
    );
  }
 
  function img_vid_addPlayPauseButtons() {
    img_vid_slides.forEach((slide, index) => {
      const desktopVideo = slide.querySelector(
        ".large-hero-banner-video.large-hero-desktop-media"
      );
      const mobileVideo = slide.querySelector(
        ".large-hero-banner-video.large-hero-mobile-media"
      );
      const playPauseButton = slide.querySelector(
        ".large-hero-pause-play-button"
      );
      const bannerWrapper = slide.closest(".large-hero-banner-wrapper");
 
      if (!playPauseButton) return;
 
      const getVisibleVideo = () => {
        return window.innerWidth > MOBILE_BREAKPOINT
          ? desktopVideo
          : mobileVideo;
      };
 
      const togglePlayPause = () => {
        const video = getVisibleVideo();
        if (!video) return;
 
        if (video.paused) {
          video.play();
          playPauseButton.classList.add("large-hero-playing");
          playPauseButton.classList.remove("large-hero-playing-two");
          videoStates[index] = false;
        } else {
          video.pause();
          playPauseButton.classList.remove("large-hero-playing");
          playPauseButton.classList.add("large-hero-playing-two");
          videoStates[index] = true;
        }
      };
 
      playPauseButton.addEventListener("click", togglePlayPause);
 
      window.addEventListener("resize", () => {
        const video = getVisibleVideo();
        if (video) {
          if (videoStates[index]) {
            video.pause();
            playPauseButton.classList.remove("large-hero-playing");
            playPauseButton.classList.add("large-hero-playing-two");
          } else {
            video.play();
            playPauseButton.classList.add("large-hero-playing");
            playPauseButton.classList.remove("large-hero-playing-two");
          }
        }
      });
 
      if (window.innerWidth <= MOBILE_BREAKPOINT) {
        bannerWrapper.addEventListener("click", () => {
          playPauseButton.classList.add("large-hero-visible");
 
          setTimeout(() => {
            playPauseButton.classList.remove("large-hero-visible");
          }, SLIDE_DURATION);
        });
      }
    });
  }
 
  // Initialize the banner
  img_vid_toggleVisibilityBasedOnBlocks();
  img_vid_showSlide(img_vid_currentIndex);
  img_vid_resetProgressBar();
  img_vid_addPlayPauseButtons();
 
  img_vid_slideInterval = setInterval(img_vid_nextSlide, img_vid_slideDuration);
})();